import { gql } from "@apollo/client";

export const AddPredefinedData = gql`
  mutation AddPredefinedData(
    $token: String!
    $user_details: SubscribedUser!
    $input: CreatePredefinedDataInput!
  ) {
    AddPredefinedData(
      token: $token
      user_details: $user_details
      input: $input
    ) {
      id
      type
      index
      value1
      value2
      value3
      value4
    }
  }
`;

export const UpdatePredefinedDataById = gql`
  mutation UpdatePredefinedDataById(
    $token: String!
    $id: ID!
    $user_details: SubscribedUser!
    $input: UpdatePredefinedDataInput!
  ) {
    UpdatePredefinedDataById(
      token: $token
      id: $id
      user_details: $user_details
      input: $input
    ) {
      id
      type
      index
      value1
      value2
      value3
      value4
    }
  }
`;

export const DeletePredefinedDataById = gql`
  mutation DeletePredefinedDataById(
    $token: String!
    $id: ID!
    $user_details: SubscribedUser!
  ) {
    DeletePredefinedDataById(
      token: $token
      id: $id
      user_details: $user_details
    )
  }
`;
